import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkCode(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;

    return (
        <code className="rounded bg-muted px-1 font-mono" {...attributes}>
            {children}
        </code>
    );
}
